import { render, staticRenderFns } from "./InviteAdminModal.vue?vue&type=template&id=37229730&"
import script from "./InviteAdminModal.vue?vue&type=script&lang=ts&"
export * from "./InviteAdminModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports